import { useCallback } from 'react'

import ChatInput from '@/components/modules/chat/ChatInput'
import ChatMessageList from '@/components/modules/chat/ChatMessageList'
import EmptyState from '@/components/modules/chat/EmptyState'
import useChat from '@/hooks/useChatTransport'
import useConversationActions from '@/hooks/useConversationActions'
import { useNavigate } from '@tanstack/react-router'

export default function NewChat() {
  const navigate = useNavigate()
  const { refetchConversations } = useConversationActions()

  const handleConversationCreated = useCallback(
    (id: string) => {
      refetchConversations()
      navigate({
        to: '/app/chat/$conversationId',
        params: { conversationId: id },
        replace: true,
      })
    },
    [refetchConversations, navigate],
  )

  const { messages, streamingContent, isStreaming, sendMessage, stop } = useChat({
    conversationId: null,
    onConversationCreated: handleConversationCreated,
  })

  const hasMessages = messages.length > 0 || isStreaming

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {hasMessages ? (
        <ChatMessageList
          messages={messages}
          streamingContent={streamingContent}
          isStreaming={isStreaming}
        />
      ) : (
        <EmptyState />
      )}
      <ChatInput onSend={sendMessage} onStop={stop} isStreaming={isStreaming} />
    </div>
  )
}
